import {
	CLEAR_SELF_RULES_ERRORS,
	CLEAR_SELF_RULES_SINGLE_ERROR,
	SELF_RULE_CREATE_LOADING,
	SELF_RULE_CREATE_ERROR,
	ALL_SELF_RULES_LOADING,
	ALL_SELF_RULES_GET,
	ALL_SELF_RULES_ERROR,
	SELF_RULE_UPDATE_LOADING,
	SELF_RULE_UPDATE_ERROR,
	SELF_RULE_STATUS_HISTORY_LOADING,
	SELF_RULE_STATUS_HISTORY_GET,
	SELF_RULE_STATUS_HISTORY_ERROR,
	SELF_RULE_DELETE_LOADING
} from '../types';

const initialState = {
	self_rule_create_loading: false,
	all_self_rules_loading: false,
	all_self_rules: { count: 0, rules: [] },
	self_rule_update_loading: false,
	self_rule_status_history_loading: false,
	self_rule_status_history: { count: 0, history: [] },
	self_rule_delete_loading: false,
	self_rules_errors: {}
}

export default function selfRulesReducer(state = initialState, action){
	switch(action.type){
		case CLEAR_SELF_RULES_ERRORS:
			return {
				...state,
				self_rules_errors: {}
			}
		case CLEAR_SELF_RULES_SINGLE_ERROR:
			return {
				...state,
				self_rules_errors: Object.keys(state.self_rules_errors).reduce((acc, key) => {
					if (key !== action.payload) {
						acc[key] = state.self_rules_errors[key];
					}
					return acc;
				}, {})
			}
		case SELF_RULE_CREATE_LOADING:
			return {
				...state,
				self_rule_create_loading: action.payload
			}
		case ALL_SELF_RULES_LOADING:
			return {
				...state,
				all_self_rules_loading: action.payload
			}
		case ALL_SELF_RULES_GET:
			return {
				...state,
				all_self_rules: {
					count: action.payload.count,
					rules: action.payload.rules
				}
			}
		case SELF_RULE_UPDATE_LOADING:
			return {
				...state,
				self_rule_update_loading: action.payload
			}
		case SELF_RULE_STATUS_HISTORY_LOADING:
			return {
				...state,
				self_rule_status_history_loading: action.payload
			}
		case SELF_RULE_STATUS_HISTORY_GET:
			return {
				...state,
				self_rule_status_history: {
					count: action.payload.count,
					history: action.payload.updates
				}
			}
		case SELF_RULE_DELETE_LOADING:
			return {
				...state,
				self_rule_delete_loading: action.payload
			}
		case SELF_RULE_CREATE_ERROR:
		case ALL_SELF_RULES_ERROR:
		case SELF_RULE_UPDATE_ERROR:
		case SELF_RULE_STATUS_HISTORY_ERROR:
			return {
				...state,
				self_rules_errors: {
					...state.self_rules_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
